/// <reference path="../../../../node_modules/@ms/office-online-strings/en-US/transcription-strings.d.ts" />

import * as React from 'react';
import { Label, Image } from 'office-ui-fabric-react';
import { AppButton } from '../../components';
import { RouteComponentProps } from 'react-router-dom';
import failureStore from '../../stores/FailureStore';
import { ChangeEvent } from '../../stores/utils';
import { LogEvents } from '../../../utils/LogEvents';
import { StartOverKeys } from '../telemetry/StartOverKeys';
import { AppLayoutSettings, getMainPageStyles } from '../common.styles';
import { StartOverClicked } from '../../actions/TranscribingActions';
import { FailureContinuation, RetryClicked } from '../../actions/FailureActions';
import { failureImageContainerStyle, failureRetryButtonContainerStyle } from './Failure.styles';
import { HostAppSettings, HostAppSettingName } from '../../../backend/office-js/HostAppSettings';

export interface FailureState {
  failureReason: string,
  failureContinuation: FailureContinuation
}

// This component is a placeholder whilst the final design is finalized
export class Failure extends React.PureComponent<RouteComponentProps, FailureState> {
  private _isMounted: boolean;

  constructor(props: RouteComponentProps) {
    super(props);
    this._isMounted = false;

    this.state = failureStore.getState();
    failureStore.on(ChangeEvent.Change, this._onStoreChanged);
  }

  private RetryButtonLabelFromFailureContinuation(continuation: FailureContinuation) {
    switch (continuation) {
      case FailureContinuation.StartOver:
        return TranscriptionStrings.StartOverFailureButtonLabel;
      case FailureContinuation.Retry:
      default:
        return TranscriptionStrings.RetryFailureButtonLabel;
    }
  }

  public componentDidMount() {
    this._isMounted = true;
  }

  public componentWillUnmount() {
    this._isMounted = false;
  }

  public render() {
    const styles = getMainPageStyles();

    return (
      <div style={AppLayoutSettings.AppCommonStyles.getPageRootContainersCSSProperties()}>
        <Label role="alert" styles={AppLayoutSettings.AppCommonStyles.getPageTopLabelStyles()}>{this.state.failureReason}</Label>
        <div className={styles.imageContainer} style={failureImageContainerStyle}>
          <Image alt="" src={require('../../../../assets/' + AppLayoutSettings.AppImageParams.failureImageName)} width={AppLayoutSettings.AppImageParams.failureImageWidthPx} height={AppLayoutSettings.AppImageParams.failureImageHeightPx} />
        </div>
        {this.state.failureContinuation != FailureContinuation.None ?
          <div className={styles.buttonContainer} style={failureRetryButtonContainerStyle}>
            <AppButton id="retryButton" type={'AppButtonProps'} text={this.RetryButtonLabelFromFailureContinuation(this.state.failureContinuation)} onExecute={this._onRetryButtonClicked} />
          </div> : null}
      </div>
    );
  }

  private _onRetryButtonClicked = async () => {
    switch (this.state.failureContinuation) {
      case FailureContinuation.Retry:
        if (HostAppSettings.IsSettingTrue(HostAppSettingName.HasStoredTranscription)) {
          await RetryClicked(this.props.history);
          break;
        }
      /* falls through */
      case FailureContinuation.StartOver:
        LogEvents.StartOver.Start([{ key: StartOverKeys.Reason, value: "Failure" }]);
        await StartOverClicked(this.props.history);
        LogEvents.StartOver.End();
        break;
      default:
        break;
    }
  }

  private _onStoreChanged = (): void => {
    if (this._isMounted) {
      this.setState(failureStore.getState());
    }
  };
}
